module.exports = __webpack_public_path__ + "static/36575D_1_0-c4f7fe07eb3ebc9b4c1833dd1a297048.ttf";